/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c8i4vh%7Bfont%3Avar(--ds-font-heading-xxsmall%2Cnormal%20653%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._onzypxbi%2B._onzypxbi%7Bmargin-top%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._7yjtidpf%20%3Ediv%7Bmargin-top%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozgv77o%7Bpadding-inline-start%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ect4ttxp%7Bfont-family%3Avar(--ds-font-family-body%2C%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1tmw%7Bcolor%3Avar(--ds-text-danger%2C%23ae2e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._s7n4nkob%7Bvertical-align%3Amiddle%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhksm61%7Bbackground-color%3Avar(--ds-background-neutral-subtle%2C%2300000000)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2hwx1b66%7Bmargin-right%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19bvze3t%7Bpadding-left%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._n3tdze3t%7Bpadding-bottom%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._u5f3ze3t%7Bpadding-right%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ca0qze3t%7Bpadding-top%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19itglyw%7Bborder%3Anone%7D");
import React, { Fragment, type KeyboardEvent, type MouseEvent, type MutableRefObject, type Ref, useCallback, useMemo, useRef } from 'react';
import { useMergeRefs } from 'use-callback-ref';
import { ErrorMessage, Field, HelperMessage } from '@atlaskit/form';
import Selectclear from '@atlaskit/icon/core/cross-circle';
import { Box, Pressable } from '@atlaskit/primitives/compiled';
import Textfield, { type TextFieldProps } from '@atlaskit/textfield';
import Tooltip from '@atlaskit/tooltip';
import { ConditionalSpotlightTargetWrapper, type ConditionalSpotlightTargetWrapperProps } from './conditional-spotlight-target-wrapper';
import { isRedoEvent, isUndoEvent } from './utils';
const styles = {
  clearTextButton: "_19itglyw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _2hwx1b66 _bfhksm61 _s7n4nkob",
  requiredIndicatorStyles: "_syaz1tmw _ect4ttxp _bozgv77o"
};

/**
 * Overriding text input margin top which design system provides as a default spacer
 * but it gets in the way of our layout
 */
const baseFieldStyles = null;
const newFieldStyles = null;
const RequiredAsterisk = () => {
  return <Box as="span" aria-hidden="true" xcss={styles.requiredIndicatorStyles}>
			*
		</Box>;
};
export type TextInputProps = Omit<TextFieldProps, 'name' | 'value'> & Pick<ConditionalSpotlightTargetWrapperProps, 'spotlightTargetName'> & {
  name: string;
  value: string;
  label?: string;
  // overrides default browser undo behaviour (cmd/ctrl + z) with that function
  onUndo?: Function;
  // overrides default browser redo behaviour (cm + shift + z / ctrl + y) with that function
  onRedo?: Function;
  onClear?: (name: string) => void;
  clearLabel?: string;
  error?: React.ReactNode;
  /** Ref to the link picker search input. */
  inputRef?: Ref<HTMLInputElement>;
  helperMessage?: string;
};
export const testIds = {
  urlError: 'link-error',
  clearUrlButton: 'clear-text',
  linkHelperText: 'link-helper-text'
};
export const TextInput = ({
  name,
  label,
  autoFocus,
  onRedo,
  onUndo,
  onKeyDown,
  onClear,
  clearLabel,
  error,
  spotlightTargetName,
  inputRef: inputRefProp,
  isRequired = false,
  helperMessage,
  ...restProps
}: TextInputProps): JSX.Element => {
  const inputRef: MutableRefObject<HTMLInputElement | null> = useRef<HTMLInputElement>(null);
  const handleRef = useCallback((input: HTMLInputElement | null) => {
    if (input) {
      inputRef.current = input;
      if (autoFocus) {
        // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
        input.focus({
          preventScroll: true
        });
      }
    }
  }, [autoFocus]);
  const refs = useMemo(() => ([handleRef, inputRefProp].filter(Boolean) as Ref<HTMLInputElement>[]), [handleRef, inputRefProp]);
  const textfieldRef = useMergeRefs(refs);
  const handleKeydown = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    if (typeof onUndo === 'function' && isUndoEvent(e)) {
      e.preventDefault();
      onUndo();
    } else if (typeof onRedo === 'function' && isRedoEvent(e)) {
      e.preventDefault();
      onRedo();
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  }, [onUndo, onRedo, onKeyDown]);
  const handleClear = useCallback((e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClear?.(name);
    inputRef.current?.focus();
  }, [name, onClear]);
  const clearText = restProps.value !== '' && <Tooltip content={clearLabel}>
			<Pressable xcss={styles.clearTextButton} onClick={handleClear} testId={testIds.clearUrlButton}>
				<Selectclear label={clearLabel || ''} color={"var(--ds-icon-subtle, #505258)"} spacing="spacious" />
			</Pressable>
		</Tooltip>;
  return <div className={ax(["_7yjtidpf _onzypxbi", "_11c8i4vh"])}>
			<Field label={label} name={name} elementAfterLabel={isRequired ? <RequiredAsterisk /> : undefined}>
				{({
        fieldProps
      }) => {
        return <ConditionalSpotlightTargetWrapper spotlightTargetName={spotlightTargetName}>
							<Fragment>
								<Textfield {...fieldProps} {...restProps} onKeyDown={handleKeydown} ref={textfieldRef} elemAfterInput={clearText} isInvalid={!!error} aria-describedby={`${restProps['aria-describedby']} ${fieldProps.id}-error ${fieldProps.id}-helper`} />
								{helperMessage && <HelperMessage testId={testIds.linkHelperText}>{helperMessage}</HelperMessage>}
								{error && <ErrorMessage testId={testIds.urlError}>{error}</ErrorMessage>}
							</Fragment>
						</ConditionalSpotlightTargetWrapper>;
      }}
			</Field>
		</div>;
};